module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/306.679ecc7c.png";